import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

/**
 * Shift-scoped data utility
 * Filters data based on the current shift window with a configurable grace period.
 */

export const isDataInShift = (
  ts: string | number | undefined,
  startTs: string | undefined,
  endTs: string | undefined,
  graceMinutes: number = 30
): boolean => {
  if (!ts || !startTs) return false;

  const start = dayjs.utc(startTs).valueOf() - graceMinutes * 60 * 1000;
  const end = endTs ? dayjs.utc(endTs).valueOf() : Date.now();
  const time = dayjs.utc(ts).valueOf();

  return time >= start && time <= end;
};
